"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationSubGroupType = exports.GenerationGroupType = exports.GenerationInputVariables = exports.GenerationInputItemType = exports.GenericTemplateExtendedContextData = exports.isHexColor = exports.HEX_COLOR_REGEX = exports.isLogoCorner = exports.DEFAULT_LOGO_CORNER = exports.LogoCorner = exports.isGenerationStrategy = exports.DEFAULT_GENERATION_STRATEGY = exports.GenerationStrategy = exports.isGenerationType = exports.GenerationType = void 0;
var GenerationType;
(function (GenerationType) {
    // Products
    GenerationType["PRODUCT_IN_INSPIRATIONAL_SCENE"] = "PRODUCT_IN_INSPIRATIONAL_SCENE";
    GenerationType["PRODUCT_IN_USE"] = "PRODUCT_IN_USE";
    GenerationType["PRODUCT_IS_PLACED"] = "PRODUCT_IS_PLACED";
    // Videos
    GenerationType["VIDEO_LAPTOP_INSPIRATIONAL"] = "VIDEO_LAPTOP_INSPIRATIONAL";
    GenerationType["VIDEO_WEBSITE_LAPTOP_PERSON"] = "VIDEO_WEBSITE_LAPTOP_PERSON";
    GenerationType["VIDEO_ACTOR_HOLDS_LAPTOP"] = "VIDEO_ACTOR_HOLDS_LAPTOP";
    GenerationType["VIDEO_ACTOR_IN_SCENE"] = "VIDEO_ACTOR_IN_SCENE";
    GenerationType["POV_HOOK_VIDEO"] = "POV_HOOK_VIDEO";
    GenerationType["HOOK_VIDEO_SPEAKING_MOBILE_APP"] = "HOOK_VIDEO_SPEAKING_MOBILE_APP";
    GenerationType["HOOK_VIDEO_SPEAKING_MOBILE_APP_VEO"] = "HOOK_VIDEO_SPEAKING_MOBILE_APP_VEO";
    GenerationType["ACTOR_HOLDS_PRODUCT_INTO_THE_CAMERA"] = "ACTOR_HOLDS_PRODUCT_INTO_THE_CAMERA";
    GenerationType["ACTOR_HOLDS_PRODUCT_IN_HAND"] = "ACTOR_HOLDS_PRODUCT_IN_HAND";
    GenerationType["ACTOR_HOLDS_PRODUCT_IN_HAND_SELFIE"] = "ACTOR_HOLDS_PRODUCT_IN_HAND_SELFIE";
    GenerationType["ACTOR_SHOWS_APP_ON_PHONE"] = "ACTOR_SHOWS_APP_ON_PHONE";
    GenerationType["APP_IN_HAND"] = "APP_IN_HAND";
    GenerationType["WALL_OF_TEXT"] = "WALL_OF_TEXT";
    GenerationType["FAST_CUTS"] = "FAST_CUTS";
    GenerationType["SORA"] = "SORA";
    GenerationType["SEEDANCE_2"] = "SEEDANCE_2";
    GenerationType["ACTOR_HOOK_DEMO"] = "ACTOR_HOOK_DEMO";
    GenerationType["ACTOR_SPEAKING"] = "ACTOR_SPEAKING";
    GenerationType["ACTOR_SPEAKING_TALKING_HEAD"] = "ACTOR_SPEAKING_TALKING_HEAD";
    GenerationType["CHARACTER_MOTION_CONTROL"] = "CHARACTER_MOTION_CONTROL";
    GenerationType["PRODUCT_ANIMATED_SHOT"] = "PRODUCT_ANIMATED_SHOT";
    GenerationType["FAST_APP_STREET_INTERVIEW"] = "FAST_APP_STREET_INTERVIEW";
    GenerationType["VIDEO_BRANDED_STREET_INTERVIEW"] = "VIDEO_BRANDED_STREET_INTERVIEW";
    GenerationType["RAGING_TEACHER"] = "RAGING_TEACHER";
    GenerationType["PODCAST_SNIPPET"] = "PODCAST_SNIPPET";
    GenerationType["PODCAST_LONG"] = "PODCAST_LONG";
    GenerationType["SHORT_CINEMATIC_SOCIAL_AD_ECOM"] = "SHORT_CINEMATIC_SOCIAL_AD_ECOM";
    GenerationType["SORA_REMIX"] = "SORA_REMIX";
    GenerationType["ACTOR_EMOTIONS"] = "ACTOR_EMOTIONS";
    GenerationType["ANIMATE_STATIC"] = "ANIMATE_STATIC";
    GenerationType["FULL_ECOM_AD_EXPERIMENT"] = "FULL_ECOM_AD_EXPERIMENT";
    GenerationType["FULL_WEBSITE_AD_EXPERIMENT"] = "FULL_WEBSITE_AD_EXPERIMENT";
    // Composite generations (multiple templates combined)
    GenerationType["COMPOSITE_LAPTOP_AD"] = "COMPOSITE_LAPTOP_AD";
    GenerationType["SORA_HOOK_DEMO_CTA"] = "SORA_HOOK_DEMO_CTA";
    // Skill-based generation (A/B testing)
    GenerationType["SKILL_BASED_STATIC"] = "SKILL_BASED_STATIC";
    // Video agent (Remotion-based video generation via Modal sandbox) — legacy path
    GenerationType["VIDEO_AGENT"] = "VIDEO_AGENT";
    // Seedance-backed video agent (Bytedance Seedance 2.0 via Fal). Short + long-form. Separate
    // from VIDEO_AGENT so analytics can tell the two pipelines apart in Metabase.
    GenerationType["SEEDANCE_VIDEO_AGENT"] = "SEEDANCE_VIDEO_AGENT";
})(GenerationType || (exports.GenerationType = GenerationType = {}));
const isGenerationType = (type) => {
    return Object.values(GenerationType).includes(type);
};
exports.isGenerationType = isGenerationType;
/**
 * Generation "strategy" / path selector for static image generations.
 *
 * Orthogonal to {@link GenerationType}: it controls HOW a static is produced
 * and post-processed, so we can try / A-B different approaches without forking
 * the template per approach.
 *
 * - `AI_LOGO`: the image model renders the brand logo directly; a
 *   post-generation "police" pass validates and, if needed, AI-repairs it.
 * - `LOGO_FREE_COMPOSITE`: the image model generates WITHOUT any logo and
 *   keeps a corner empty; the real (transparent) brand logo is then stamped
 *   onto the image programmatically. No police pass.
 */
var GenerationStrategy;
(function (GenerationStrategy) {
    GenerationStrategy["AI_LOGO"] = "ai_logo";
    GenerationStrategy["LOGO_FREE_COMPOSITE"] = "logo_free_composite";
})(GenerationStrategy || (exports.GenerationStrategy = GenerationStrategy = {}));
/** Backwards-compatible default: existing generations keep the AI-logo path. */
exports.DEFAULT_GENERATION_STRATEGY = GenerationStrategy.AI_LOGO;
const isGenerationStrategy = (value) => {
    return Object.values(GenerationStrategy).includes(value);
};
exports.isGenerationStrategy = isGenerationStrategy;
/**
 * Where the real logo is stamped onto a `LOGO_FREE_COMPOSITE` static. The
 * chosen corner must match the corner the prompt keeps empty.
 *
 * `NONE` is a special value meaning "do not place any logo at all" — the model
 * generates a fully logo-free static and no programmatic stamp is applied.
 */
var LogoCorner;
(function (LogoCorner) {
    LogoCorner["BOTTOM_LEFT"] = "bottom-left";
    LogoCorner["BOTTOM_RIGHT"] = "bottom-right";
    LogoCorner["TOP_LEFT"] = "top-left";
    LogoCorner["TOP_RIGHT"] = "top-right";
    LogoCorner["NONE"] = "none";
})(LogoCorner || (exports.LogoCorner = LogoCorner = {}));
exports.DEFAULT_LOGO_CORNER = LogoCorner.BOTTOM_LEFT;
const isLogoCorner = (value) => {
    return Object.values(LogoCorner).includes(value);
};
exports.isLogoCorner = isLogoCorner;
/** Matches a 6-digit hex color like `#FFFFFF`. Used to validate logo recolor input. */
exports.HEX_COLOR_REGEX = /^#([0-9a-fA-F]{6})$/;
const isHexColor = (value) => exports.HEX_COLOR_REGEX.test(value);
exports.isHexColor = isHexColor;
var GenericTemplateExtendedContextData;
(function (GenericTemplateExtendedContextData) {
    GenericTemplateExtendedContextData["BRAND_LANGUAGE"] = "brandLanguage";
    GenericTemplateExtendedContextData["BRAND_LOGO"] = "brandLogo";
    GenericTemplateExtendedContextData["BRAND_COLORS"] = "brandColors";
    GenericTemplateExtendedContextData["APP_ICON"] = "appIcon";
})(GenericTemplateExtendedContextData || (exports.GenericTemplateExtendedContextData = GenericTemplateExtendedContextData = {}));
var GenerationInputItemType;
(function (GenerationInputItemType) {
    GenerationInputItemType["PRODUCT_IMAGES"] = "productImages";
    GenerationInputItemType["REFERENCE_IMAGES"] = "referenceImages";
    GenerationInputItemType["ACTORS"] = "actors";
    GenerationInputItemType["ACTOR_EMOTION"] = "actorEmotion";
    GenerationInputItemType["INPUT"] = "input";
    GenerationInputItemType["SCRIPT"] = "script";
    GenerationInputItemType["PRODUCT_DESCRIPTION"] = "productDescription";
    GenerationInputItemType["MODE"] = "mode";
    GenerationInputItemType["AUDIO_FILE"] = "audioFile";
    GenerationInputItemType["ACTOR_SCENE_FILE"] = "actorSceneFile";
})(GenerationInputItemType || (exports.GenerationInputItemType = GenerationInputItemType = {}));
exports.GenerationInputVariables = {
    ...GenerationInputItemType,
    ...GenericTemplateExtendedContextData,
};
var GenerationGroupType;
(function (GenerationGroupType) {
    GenerationGroupType["ALL"] = "all";
    GenerationGroupType["VIDEO"] = "video";
    GenerationGroupType["MOBILE_APP"] = "mobile-app";
    GenerationGroupType["E_COMMERCE"] = "e-commerce";
})(GenerationGroupType || (exports.GenerationGroupType = GenerationGroupType = {}));
var GenerationSubGroupType;
(function (GenerationSubGroupType) {
    GenerationSubGroupType["AI_UGC"] = "ai-ugc";
    GenerationSubGroupType["HOOKS"] = "hooks";
    GenerationSubGroupType["SCENES"] = "scenes";
    GenerationSubGroupType["VIDEO_ADS"] = "video-ads";
    GenerationSubGroupType["EXPERIMENTAL"] = "experimental";
})(GenerationSubGroupType || (exports.GenerationSubGroupType = GenerationSubGroupType = {}));
